// Purpose: Customer API calls
// Caller: customerAction, ProductOutCreatePage
// Dependencies: utils/xhr
// Main Functions: getCustomers, createCustomer, updateCustomer, deleteCustomer
// Side Effects: HTTP CRUD /customer

import { xhr } from 'utils'

export const getCustomers = (params = '') => xhr.get(`/customer?${params}`)
export const createCustomer = (data) => xhr.post('/customer', data)
export const updateCustomer = (data, id) => xhr.put(`/customer/${id}`, data)
export const deleteCustomer = (id) => xhr.delete(`/customer/${id}`)
